<template>
    <div class="container mt-5">
        <h1>Hotels</h1>

        <h3>A few words about hotels and apartments in Budapest:</h3>
        <p>
            In most hotels and apartments in Budapest, you can receive the Hungarian escort girl from Budapest discreetly and without additional reception fees. There are only a few hotels and apartments where the reception staff ask for an extra amount at the time of the visit (depending on the staff). This amount is usually 20-30 euros and typically occurs in older hotels, where the staff follows old (unfriendly) customs. Guest-friendly hotels and apartments avoid unpleasantness and impersonality towards the guest. In order to avoid inconvenience, inquire in advance about the conditions for hosting guests in the given hotel or apartment!
        </p>

        <h3>A few words about Budapest escort girls, Hungarian escort girls:</h3>
        <p>
            Escort Budapest girls always manage the visit discreetly and avoid being conspicuous for the sake of the guest. The visit of the Budapest escorts girls takes place at the time according to the preliminary SMS message, according to the agreement. The escorts Budapest girls are very pretty, discreet and always speak a foreign language, which is usually English. The escorts in Budapest girls are beautiful and kind and in no way foreign. The general wording escort girl budapest is a general description of Hungarian escort girls, which is also a guarantee that only Hungarian girls advertise on the website. The escort service in Budapest is advertised exclusively by professional, pretty and pleasant, sociable ladies, which is a guarantee that the client will have a pleasant time.
We wish you a pleasant time in Budapest!
        </p>
        <div v-for="hotel in hotels" :key="hotel.id">
            <h4>{{ hotel.name}}</h4>
            <p>
                {{ hotel.city }}<br>
                {{ hotel.address }}<br>
                {{ hotel.zip }}<br>
                <a :href="hotel.website" target="_blank">{{ hotel.website }}</a>
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Hotels",
        metaInfo: {
            title: 'Hotels'
        },
        data() {
            return {
                hotels: []
            }
        },
        created() {
            this.fetchData()
        },
        methods: {
            fetchData() {
                this.$http.get(`${process.env.VUE_APP_API_URL}/hotels`)
                    .then((response) => {
                        this.hotels = response.data
                    })
            }
        }
    }
</script>

<style scoped>

</style>
